export const KeyboardInputKey = {
  Enter: "Enter",
};
